import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tt_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "rug_tufting", label: "Rug Tufting" },
  { id: "tuft_sip", label: "Sip" },
  { id: "tuft_buddies", label: "Tuft Buddies" },
  { id: "doormat_painting", label: "Doormat Painting" },
  { id: "seasonal", label: "Seasonal" },
  { id: "youth", label: "Youth" },
  { id: "special", label: "Special Events" },
];

export const GALLERY_CATEGORIES = [
  { id: "all", label: "All" },
  { id: "workshops", label: "Rug Workshops" },
  { id: "private_parties", label: "Private Parties" },
  { id: "corporate", label: "Corporate Events" },
  { id: "custom_rugs", label: "Custom Rugs" },
  { id: "tuft_buddies", label: "Tuft Buddies" },
  { id: "mobile", label: "Mobile Events" },
];

export const originUrl = () => window.location.origin;

const IMAGE_EXT = /\.(heic|heif|jpe?g|png)$/i;
export const isAllowedImage = (file, allowPdf = false) => {
  const t = (file.type || "").toLowerCase();
  if (["image/jpeg", "image/jpg", "image/png", "image/heic", "image/heif"].includes(t)) return true;
  if (allowPdf && (t === "application/pdf" || /\.pdf$/i.test(file.name))) return true;
  return IMAGE_EXT.test(file.name || "");
};

export const fmtTime12 = (t) => { if (!t) return ""; const [h, m] = String(t).split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m || 0).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`; };
export const fmtDateLong = (d, opts = { weekday: "long", month: "long", day: "numeric" }) => (d ? new Date(d + "T12:00:00").toLocaleDateString("en-US", opts) : "");
